import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  SortDirection,
} from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import BasicTabComponent from '../../../../components/BasicTabComponent';
import AddButtonComponent from '../../../../components/form/AddButtonComponent';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useNavigate, useParams } from 'react-router-dom';

import { useStore } from '../../../../utils/store';
import Constants from '../../../../utils/constants';
import HttpServices from '../../../../services/HttpService';

import SimpleDialogComponent from '../../../../components/SimpleDialogComponent';
import CrewLabourListComponent from './LaboursList';
import PaginateDataModel from '../../../../Models/PaginateDataModel';
import CrewMobileAssetsListComponent from './MobileAssetsList';
import SimpleSearchComponent from '../../../../components/SimpleSearchComponent';
import AlertMessageComponent from '../../../../components/AlertMessageComponent';
import { useAlert } from '../../../../components/alertContext';
import { Edit } from '@mui/icons-material';
import FormFieldData from '../../../../Models/FormFieldData';
import CommonForm from '../../../../components/form/CommonForm';
const CrewsDashboard: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const isInitialLoad = useRef(true);
  const { currentId } = useParams<{ currentId: any }>();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [searchQueryLabour, setSearchQueryLabour] = useState<any>('');
  const [totalRecordsLabour, setTotalRecordsLaobur] = useState<number>(0);
  const [labourList, setLabourList] = useState<any>([]);
  const [selectedLabourList, setSelectedLabourList] = useState<any>([]);
  const [selectedLabourListIds, setSelectedLabourListIds] = useState<any>([]);
  const [addLabourDialogOpen, setAddLabourDialogOpen] =
    useState<boolean>(false);
  const [paginateLabourList, setPaginateLabourList] =
    useState<PaginateDataModel>({
      limit: Constants.DEFAULT_PAGE_SIZE,
      offset: 0,
    });
  const [searchQueryMobileAssets, setSearchQueryMobileAssets] =
    useState<any>('');
  const [loading, setLoading] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [totalRecordsMobileAssets, setTotalRecordsMobileAssets] =
    useState<number>(0);
  const [mobileAssetsList, setMobileAssetsList] = useState<any>([]);
  const [selectedMobileAssetsList, setSelectedMobileAssetsList] = useState<any>(
    []
  );
  const [selectedMobileAssetsListIds, setSelectedMobileAssetsListIds] =
    useState<any>([]);

  const [addMobileAssetDialogOpen, setAddMobileAssetDialogOpen] =
    useState<boolean>(false);
  const { getAdmin } = useStore();
  const navigate = useNavigate();

  const [paginateMobileAssetList, setPaginateMobileAssetList] =
    useState<PaginateDataModel>({
      limit: Constants.DEFAULT_PAGE_SIZE,
      offset: 0,
    });
  type CrewsObj = {
    [k: string]: { required: boolean; value: string | null };
  };
  const [crewsForm, setCrewsForm] = useState<CrewsObj>({
    id: { required: false, value: null },
    name: { required: true, value: '' },
  });
  const [orderByLabour, setOrderByLabour] = useState<any>('created');
  const [orderLabour, setOrderLabour] = useState<SortDirection>('desc');
  const handleOrderByLabour = (orderByColumn: any) => {
    setOrderByLabour(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (orderLabour === 'desc') {
      setOrderLabour('asc');
      return;
    } else {
      setOrderLabour('desc');
      return;
    }
  };
  const [orderByMobile, setOrderByMobile] = useState<any>('created');
  const [orderMobile, setOrderMobile] = useState<SortDirection>('desc');
  const handleOrderByMobile = (orderByColumn: any) => {
    setOrderByMobile(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (orderMobile === 'desc') {
      setOrderMobile('asc');
      return;
    } else {
      setOrderMobile('desc');
      return;
    }
  };
  const labourColumns = [
    {
      field: 'firstName',
      headerName: 'First Name',
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
    },
    {
      field: '',
      headerName: '',
      renderCell: (row: any) => (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="close"
            onClick={() => {
              handleDelete('labour', row.id);
            }}
          >
            <DeleteOutlinedIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  const mobileAssetsColumns = [
    {
      field: 'assetNumber',
      headerName: 'Asset Number',
    },
    {
      field: 'assetName',
      headerName: 'Asset Name',
    },
    {
      field: '',
      headerName: '',
      renderCell: (row: any) => (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="close"
            onClick={() => {
              handleDelete('mobileasset', row.id);
            }}
          >
            <DeleteOutlinedIcon />
          </IconButton>
        </Box>
      ),
    },
  ];
  useEffect(() => {
    if (isInitialLoad.current) {
      fetchLabourList();
      fetchMobileAssetsList();
      fetchSelectedMobileAssetsList();
      fetchSelectedLabourList();

      if (currentId) {
        if (currentId !== 'Add') {
          fetchSingleRecord(currentId);
        }
      } else {
        setCurrentRecord(null);
      }

      isInitialLoad.current = false;
    }
  }, [currentId]);
  useEffect(() => {
    fetchLabourList();
  }, [searchQueryLabour, paginateLabourList]);
  useEffect(() => {
    fetchMobileAssetsList();
  }, [searchQueryMobileAssets, paginateMobileAssetList]);
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setCrewsForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Crew Name',
      value: crewsForm.name.value,
      onChange: handleInputChange,
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Crew name is required' : '')],
    },
  ];
  const fetchSingleRecord = async (id: any) => {
    try {
      const response = await HttpServices.get(
        Constants.apiURL + Constants.crewsURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  /* Labour Operations Starts Here */
  const fetchLabourList = async () => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.labourURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          search: searchQueryLabour,
          limit: paginateLabourList.limit,
          offset: paginateLabourList.offset,
          isActive: 1,
        }
      );
      if (response.success) {
        setLabourList(response.data.paginateRecords);
        setTotalRecordsLaobur(response.data.total);
        setOrderByLabour('firstName');
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchSelectedLabourList = async () => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.crewsURL}/${currentId}/labour`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        setSelectedLabourList(response.data.crewLabours);
        const idArray = response.data.crewLabours.map(
          (item: any) => item.labour.id
        );
        console.log(idArray, '<<<<<<<<<<<<<<<<<');
        setSelectedLabourListIds(idArray);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleSaveLabour = async () => {
    try {
      const response = await HttpServices.post(
        `${Constants.apiURL}${Constants.crewsURL}/${currentId}/labour`,
        { labourIds: selectedLabourListIds },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        fetchSelectedLabourList();
        if (currentId !== 'Add') {
          fetchSingleRecord(currentId);
        }
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  /* labour Operations Ends here */

  /* Mobile Assets Operations Starts Here */
  const fetchMobileAssetsList = async () => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.mobileAssetsURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          search: searchQueryMobileAssets,
          limit: paginateMobileAssetList.limit,
          offset: paginateMobileAssetList.offset,
          isActive: 1,
        }
      );
      if (response.success) {
        setMobileAssetsList(response.data.paginateRecords);
        setTotalRecordsMobileAssets(response.data.total);
        setOrderByMobile('id');
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchSelectedMobileAssetsList = async () => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.crewsURL}/${currentId}/mobileasset`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        setSelectedMobileAssetsList(response.data.crewMobileAssets);
        const idArray = response.data.crewMobileAssets.map(
          (item: any) => item.mobileAsset.id
        );
        console.log(idArray, '<<<<<<<<<<<<<<<<<');
        setSelectedMobileAssetsListIds(idArray);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleSaveMobileAssets = async () => {
    try {
      const response = await HttpServices.post(
        `${Constants.apiURL}${Constants.crewsURL}/${currentId}/mobileasset`,
        { mobileAssetIds: selectedMobileAssetsListIds },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        fetchSelectedMobileAssetsList();
        if (currentId !== 'Add') {
          fetchSingleRecord(currentId);
        }
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  /* Mobile Assets Operations Ends Here */
  const handleDelete = async (type: string, id: any) => {
    try {
      const response = await HttpServices.patch(
        `${Constants.apiURL}${Constants.crewsURL}/${type}`,
        { id, status: '0' },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        if (type === 'labour') fetchSelectedLabourList();
        if (type === 'mobileasset') fetchSelectedMobileAssetsList();
        if (currentId !== 'Add') {
          fetchSingleRecord(currentId);
        }
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleRowClick = async (data: any) => {
    console.log(data);
    setCurrentRecord(data);
    setCrewsForm({
      id: { required: false, value: data.id },
      name: { required: true, value: data.name },
    });
  };
  const handleStatus = (row: any, type: string) => {
    handleSelectedIds(row.id, type);
  };
  const handleSelectedIds = async (id: any, type: string) => {
    console.log(id);
    if (type === 'labour') {
      setSelectedLabourListIds((prevItems: any) => {
        const newItems = [...prevItems];
        if (!newItems.includes(id)) {
          newItems.push(id);
        } else {
          newItems.splice(newItems.indexOf(id), 1);
        }
        return newItems;
      });
    }
    if (type === 'mobileasset') {
      setSelectedMobileAssetsListIds((prevItems: any) => {
        const newItems = [...prevItems];
        if (!newItems.includes(id)) {
          newItems.push(id);
        } else {
          newItems.splice(newItems.indexOf(id), 1);
        }
        return newItems;
      });
    }
  };
  const handlePagination = (paginationData: any, type: string) => {
    console.log(paginationData);
    if (type === 'labour') setPaginateLabourList(paginationData);
    if (type === 'mobileasset') setPaginateMobileAssetList(paginationData);
  };

  const LabourDialogContent = () => {
    return (
      <Box className="row mb-3 mt-2" sx={{ textAlign: 'right' }}>
        <Typography component={'h1'} sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
          Add Labourers
        </Typography>
        <Box sx={{ width: '800px' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              mt: 2,
            }}
          >
            <SimpleSearchComponent
              onSearch={(event: any) => {
                setSearchQueryLabour(event.target.value);
              }}
              search={searchQueryLabour}
            />
          </Box>
          <CrewLabourListComponent
            handleStatus={handleStatus}
            recordList={labourList}
            selectedRecords={selectedLabourListIds}
            totalRecords={totalRecordsLabour}
            paginate={paginateLabourList}
            handleOrderBy={handleOrderByLabour}
            order={orderLabour}
            orderBy={orderByLabour}
            handlePagination={handlePagination}
          ></CrewLabourListComponent>
        </Box>
        <Button
          color="primary"
          sx={{ color: '#fff !important', mt: 3, mb: 3, textAlign: 'right' }}
          variant="contained"
          onClick={() => {
            handleSaveLabour();
            setAddLabourDialogOpen(false);
            setPaginateLabourList({
              limit: Constants.DEFAULT_PAGE_SIZE,
              offset: 0,
            });
          }}
        >
          Save
        </Button>
      </Box>
    );
  };

  const crewNameFormContent = () => {
    return (
      <CommonForm
        singlePage={true}
        fields={formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={'Update Crew'}
        isLoading={loading}
        isUpdate={true}
        onSave={handleSaveCrewName}
        actionButtonPosition="bottom"
      />
    );
  };
  const MobileAssetDialogContent = () => {
    return (
      <Box className="row mb-3 mt-2" sx={{ textAlign: 'right' }}>
        <Typography component={'h1'} sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
          Add Mobile Asset
        </Typography>
        <Box sx={{ width: '800px' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              mt: 2,
            }}
          >
            <SimpleSearchComponent
              onSearch={(event: any) => {
                setSearchQueryMobileAssets(event.target.value);
              }}
              search={searchQueryMobileAssets}
            />
          </Box>
          <CrewMobileAssetsListComponent
            handleStatus={handleStatus}
            recordList={mobileAssetsList}
            selectedRecords={selectedMobileAssetsListIds}
            totalRecords={totalRecordsMobileAssets}
            paginate={paginateMobileAssetList}
            handlePagination={handlePagination}
            order={orderMobile}
            orderBy={orderByMobile}
            handleOrderBy={handleOrderByMobile}
          ></CrewMobileAssetsListComponent>
        </Box>
        <Button
          color="primary"
          sx={{ color: '#fff !important', mt: 3, mb: 3, textAlign: 'right' }}
          variant="contained"
          onClick={() => {
            handleSaveMobileAssets();
            setAddMobileAssetDialogOpen(false);
            setPaginateMobileAssetList({
              limit: Constants.DEFAULT_PAGE_SIZE,
              offset: 0,
            });
          }}
        >
          Save
        </Button>
      </Box>
    );
  };
  const clearForm = () => {
    setCrewsForm({
      id: { required: false, value: null },
      name: { required: true, value: '' },
    });
    setUpdateDialog(false);
    fetchSingleRecord(currentId);
    setAlert({
      type: 'success',
      message: 'Saved',
      open: true,
    });
  };
  const handleSaveCrewName = async () => {
    setLoading(true);
    const reqData: any = {
      id: crewsForm.id.value,
      name: crewsForm.name.value,
    };
    const endpoint = `${Constants.apiURL + Constants.crewsURL}`;
    let response: any;
    try {
      response = await HttpServices.put(endpoint, reqData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const TabTable = () => {
    const rows: { [k: string]: string | number }[] =
      tabIndex === 0 ? selectedLabourList : selectedMobileAssetsList;
    const columns: any[] = tabIndex === 0 ? labourColumns : mobileAssetsColumns;

    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead style={{ background: ' rgba(0, 244, 255, 0.06)' }}>
            <TableRow>
              {columns.map((column, indexc) => (
                <TableCell key={'tblcell_' + column.field + '_' + indexc}>
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row: any) => (
              <TableRow key={'tblrowbody_' + row.id}>
                {columns.map((column, index: any) => (
                  <TableCell key={'tblbodycell_' + index + '_' + column.field}>
                    {column.renderCell
                      ? column.renderCell(row)
                      : tabIndex === 0
                        ? row['labour'][column.field]
                        : row['mobileAsset'][column.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const TabContent = () => {
    return (
      <Box sx={{ display: 'grid', gap: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '20px',
          }}
        >
          <Typography>
            {tabIndex === 0 ? 'Labourers' : 'Mobile Assets'}
          </Typography>
          <AddButtonComponent
            keyName="add_tabbtn"
            label={tabIndex === 0 ? 'Add Labourers' : 'Add Mobile Assets'}
            onClick={() => {
              if (tabIndex === 0) setAddLabourDialogOpen(true);
              if (tabIndex === 1) setAddMobileAssetDialogOpen(true);
            }}
          />
        </Box>

        <TabTable />
      </Box>
    );
  };

  const changeTabHandler = (newIndex: number) => setTabIndex(newIndex);

  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                navigate('/data-management/crews');
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>

            <Typography variant="h6" sx={{ mb: '24px' }}>
              Crews
            </Typography>

            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                }}
              >
                <Box sx={{ display: 'grid', gap: '16px' }}>
                  <Typography sx={{ fontWeight: 500 }}>Crew details</Typography>
                  {currentRecord && (
                    <Box
                      sx={{
                        padding: '18px 16px',
                        backgroundColor: '#F9F9F9',
                        border: '1px solid #EFEEED',
                        borderRadius: '6px',
                        display: 'flex',
                        gap: '48px',
                      }}
                    >
                      <Box sx={{ width: '220px', display: 'grid', gap: '8px' }}>
                        <Typography sx={{ fontSize: '14px', color: '#666666' }}>
                          Crew Name
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '14px',
                            color: '#464646',
                            fontWeight: '500',
                          }}
                        >
                          {currentRecord.name}
                          <IconButton
                            onClick={() => {
                              setUpdateDialog(true);
                            }}
                          >
                            {' '}
                            <Edit fontSize="small" />
                          </IconButton>
                        </Typography>
                      </Box>
                      <Box sx={{ width: '220px', display: 'grid', gap: '8px' }}>
                        <Typography sx={{ fontSize: '14px', color: '#666666' }}>
                          # of Personnel
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '14px',
                            color: '#464646',
                            fontWeight: '500',
                          }}
                        >
                          {currentRecord.totalLabours}
                        </Typography>
                      </Box>
                      <Box sx={{ width: '220px', display: 'grid', gap: '8px' }}>
                        <Typography sx={{ fontSize: '14px', color: '#666666' }}>
                          # of Mobile Assets
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '14px',
                            color: '#464646',
                            fontWeight: '500',
                          }}
                        >
                          {currentRecord.totalMobileAssets}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>

                <BasicTabComponent
                  labels={['Labourers', 'Mobile Assets']}
                  tabContent={<TabContent />}
                  onChangeTab={changeTabHandler}
                />
              </Box>
              <SimpleDialogComponent
                title={''}
                dialogContent={LabourDialogContent()}
                open={addLabourDialogOpen}
                handleClose={() => {
                  setAddLabourDialogOpen(false);
                  setPaginateLabourList({
                    limit: Constants.DEFAULT_PAGE_SIZE,
                    offset: 0,
                  });
                }}
              />
              <SimpleDialogComponent
                title={''}
                dialogContent={MobileAssetDialogContent()}
                open={addMobileAssetDialogOpen}
                handleClose={() => {
                  setAddMobileAssetDialogOpen(false);
                  setPaginateMobileAssetList({
                    limit: Constants.DEFAULT_PAGE_SIZE,
                    offset: 0,
                  });
                }}
              />
              <SimpleDialogComponent
                title={''}
                dialogContent={crewNameFormContent()}
                open={updateDialog}
                handleClose={() => {
                  setUpdateDialog(false);
                  clearForm();
                }}
              />
            </Paper>
          </div>
        </div>
      </section>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default CrewsDashboard;
